// Module registry that drives the client nav + routes.
//
// Seeded at scaffold time (a snapshot of the backend modules.config.js) so the
// SPA has an instant, offline-capable first paint — then reconciled at runtime
// from GET /api/meta/modules so edits to modules.config.js show up WITHOUT a
// client rebuild. The runtime copy is the single source of truth; the seed is
// only the first-paint fallback. Consume via useModules().
import { useState, useEffect } from 'react';
import axios from 'axios';

export const seedModules = {
  "core": {
    "key": "core",
    "label": "Core",
    "icon": "layout-dashboard",
    "models": [
      "User",
      "Role",
      "Permission",
      "ApiToken",
      "AuditLog"
    ],
    "routes": [
      "/admin",
      "/admin/users",
      "/admin/roles",
      "/admin/permissions",
      "/admin/api-tokens",
      "/admin/audit-log"
    ],
    "actions": [
      "view",
      "create",
      "update",
      "delete",
      "manage_tokens"
    ],
    "instanceScoped": []
  },
  "site": {
    "key": "site",
    "label": "Website",
    "icon": "newspaper",
    "models": [
      "CmsContent",
      "Service",
      "ClientLogo",
      "Testimonial",
      "GalleryPhoto",
      "Enquiry"
    ],
    "routes": [
      "/admin/cms-content",
      "/admin/service",
      "/admin/client-logo",
      "/admin/testimonial",
      "/admin/gallery-photo",
      "/admin/enquiry"
    ],
    "actions": [
      "view",
      "create",
      "update",
      "delete"
    ],
    "instanceScoped": []
  }
};
export default seedModules;

// Shared across hook instances: once the live registry arrives, later mounts
// (and a second consumer on the same page) start from the fresh copy.
let cache = seedModules;

/** Live module registry — seeded from the build-time copy, reconciled from the API. */
export function useModules() {
  const [modules, setModules] = useState(cache);
  useEffect(() => {
    let active = true;
    axios
      .get('/api/meta/modules', { withCredentials: true })
      .then((res) => {
        if (active && res.data && typeof res.data === 'object') {
          cache = res.data;
          setModules(res.data);
        }
      })
      .catch(() => {
        /* offline / not yet reachable — keep the seeded copy */
      });
    return () => {
      active = false;
    };
  }, []);
  return modules;
}
